const styles = (theme) => ({
  scHeaderCloseButton: {
    boxSizing: "border-box",
    cursor: "pointer",
    borderRadius: "5px",
    color: theme.iconColor,
  },
  scHeaderCloseIcon: {
    padding: "4",
    fontSize: "21px",
  },
  scHeaderMsgIcon: {
    padding: "4",
    fontSize: "21px",
    "&:hover": {
      fill: theme.HeaderSelectedText,
    },
  },
  scDisabledHeaderMsgIcon: {
    color: theme.iconColor,
    pointerEvents: "none",
    cursor: "not-allowed",
    padding: "4",
    fontSize: "21px",
  },
  scUrgentMsgOutlined: {
    padding: "4",
    fontSize: "21px",
    "&:hover": {
      fill: theme.HeaderSelectedText,
    },
  },
  scUrgentMsgFilled: {
    fill: theme.urgentColor,
    padding: "4",
    fontSize: "21px",
  }
});

export default styles;
